import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=0e82c095&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=0e82c095&prod&lang=css"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=0e82c095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82c095",
  null
  
)

export default component.exports